import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n"; 
export default {

    addReturnOrder( formData){
        return axios.post('/api/claim/add/return-order', formData , { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
            
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.simple(error);})
    },

    addClaim( claim){
        return axios.post('/api/claim/add/claim', claim)
        .then(response => {
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {console.log(error);})
    },

    changeStatus(id, status){
        return axios.post('/api/claim/change-status', {id:id, status: status})
        .then(response => {
            
            if (response && response.data) {
                return response.data;
            } 
        })
        .catch(error => {console.log(error);})

    },

    getClaims (page, pageSize ,isClaim) {
        return axios.get('/api/claim/list', { params: {page: page, pageSize: pageSize ,isClaim:isClaim} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    sendContactUsMail (ContactUs) {
        return axios.post('/api/claim/contact-us', ContactUs)
        .then(response => {
            if (response && response.data) 
                {
                    Vue.prototype.$snotify.simple(i18n.t('services.users.sendMailContactUs'))
                    return response.data

                }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
}

